<template>
  <div class="main-body">

    <div class="header">血压计</div>

    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">绑定设备</el-button>

        <div style="float:right">

          <el-input placeholder="输入老人姓名" v-model="name" clearable style="margin-right:10px;width:120px"></el-input>
          <el-input placeholder="输入手机号" v-model="phone" clearable style="margin-right:10px;width:140px"></el-input>
          <el-input placeholder="输入SN号" v-model="sn" clearable style="margin-right:10px;width:140px"></el-input>

          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="选择区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                        style="width:140px;margin-right:10px"></elSelectTree>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">

        <el-table-column prop="userName" label="用户姓名"></el-table-column>

        <el-table-column prop="phone" label="手机号" :formatter="getPhoneStr"></el-table-column>

        <el-table-column prop="sn" label="SN号"></el-table-column>

        <el-table-column prop="bindTime" label="绑定时间" :formatter="timefilter"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="success" size="mini"  @click="getData(scope.$index, scope.row)">数据</el-button>
            <el-button type="danger" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change"></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"  v-on:getList="getList"></Add>
    <LXXueYaJiDataPage ref="LXXueYaJiDataPage" v-show="lXXueYaJiDataPageShow" v-on:closeLXXueYaJiDataPage="closeLXXueYaJiDataPage"></LXXueYaJiDataPage>

  </div>
</template>

<script>

import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Add from "./AddDisable"
import LXXueYaJiDataPage from "./DataAiaole";
import elSelectTree from "@/components/ElSelectTree"


export default {
  name: "Role",
  data() {
    return {
      tableLoading:false,

      showModalGetElderly:false,
      showModalAdd:false,
      lXXueYaJiDataPageShow:false,

      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      name:"",
      phone: "",
      sn: "",


      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      zoneValue: [],
      zoneCode: '',



    };
  },
  components: {Add,LXXueYaJiDataPage,elSelectTree},
  created() {
    this.th = this.$store.state.tableHeight;
    this.getZone();
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {
    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },

    getPhoneStr(row,index,column){
      let str = "";
      if(column && column.length == 11){
        str = column.substring(0,3)+"****"+column.substring(7,11);
      }else{
        str = column;
      }
      return str;
    },


    closeGetElderly: function () {
      this.showModalGetElderly = !this.showModalGetElderly;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    closeLXXueYaJiDataPage(){
      this.lXXueYaJiDataPageShow =!this.lXXueYaJiDataPageShow;
    },
    getData(index,row){
      this.$refs.LXXueYaJiDataPage.init(row.userCode);
      this.lXXueYaJiDataPageShow =!this.lXXueYaJiDataPageShow;
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceXYJAAL/PageByZoneCodeClassName",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,

          phone: this.phone,
          sn: this.sn,
          name:this.name,
          zoneCode:this.zoneCode,
          elderlyClassName:'残疾人',

        },
      }).then((response) => {
        this.tableLoading=false
        if (response.data.error == 0) {

          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    //日期格式
    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceXYJAAL/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            deviceXyjAiaoleCode: row.deviceXyjAiaoleCode,
          },
        }).then((response) => {

          if (response.data.error == 0) {
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });


      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消解绑",
        });
      });
    },

    getZone(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        //console.log(response.data.data);
        if (response.data.error == 0) {
          var data = JSON.stringify(response.data.data);

          //console.log(data.replace(/"listZoneDTO":\[\],/g, ''));

          data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
          this.zoneValue = data;
          this.zoneCode = data[0].zoneCode;

          this.getList();

        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      })

    },


    getZoneValue(val) {
      this.zoneCode = val
    },

  },
};
</script>

<style scoped>
</style>
